// services/incident.service.ts
import { apiService } from "../../app.service";

export const incidentApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Fetch a incident with location
    fetchIncident: builder.query({
      query: ({ id, locationId }) => ({
        url: `/incident/${id}${locationId ? `?locationId=${locationId}` : ''}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "incident", id: result._id }] : [],
    }),

    // ✅ Fetch all incidents with location
    fetchIncidents: builder.query({
      query: (locationId) => {
        const params = locationId ? `?locationId=${locationId}` : '';
        return {
          url: `/incident${params}`,
        };
      },
      providesTags: ["incidents"],
    }),

    // ✅ Create a new incident (location handled by backend)
    createIncident: builder.mutation({
      query: (data) => ({
        url: "/incident",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["incidents"],
    }),

    // ✅ Update an existing incident with location
    updateIncident: builder.mutation({
      query: ({ id, data, locationId }) => ({
        url: `/incident/${id}${locationId ? `?locationId=${locationId}` : ''}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "incident", id },
        "incidents",
      ],
    }),

    // ✅ Delete a incident with location
    deleteIncident: builder.mutation({
      query: ({ id, locationId }) => ({
        url: `/incident/${id}${locationId ? `?locationId=${locationId}` : ''}`,
        method: "DELETE",
      }),
      invalidatesTags: ["incidents"],
    }),
  }),
});

export const {
  useFetchIncidentsQuery,
  useFetchIncidentQuery,
  useCreateIncidentMutation,
  useUpdateIncidentMutation,
  useDeleteIncidentMutation,
} = incidentApi;